export const getPageNumbers = (currentPage, totalPages) => {
	const totalVisiblePages = 3;
	const pageNumbers = [];
	let startPage, endPage;

	if (totalPages <= totalVisiblePages) {
		startPage = 1;
		endPage = totalPages;
	} else if (currentPage === 1) {
		startPage = 1;
		endPage = totalVisiblePages;
	} else if (currentPage === totalPages) {
		startPage = totalPages - (totalVisiblePages - 1);
		endPage = totalPages;
	} else {
		startPage = currentPage - 1;
		endPage = currentPage + 1;
	}

	for (let i = startPage; i <= endPage; i++) {
		pageNumbers.push(i);
	}

	return pageNumbers;
};

const getTextFromReactNode = (node) => {
	if (node == null || typeof node === 'boolean') {
		return '';
	}

	if (typeof node === 'string' || typeof node === 'number') {
		return String(node);
	}

	if (Array.isArray(node)) {
		return node.map(getTextFromReactNode).join('');
	}

	if (typeof node === 'object' && node.props) {
		return getTextFromReactNode(node.props.children);
	}

	return '';
};

export const copyPostQCLogToClipboard = async (toastContent) => {
	const processedData = toastContent.map(([time, content]) => [
		time,
		getTextFromReactNode(content)
	]);

	const clipboardText = processedData
		.map(([time, message]) => `${time} - ${message}`)
		.join('\n');

	try {
		await navigator.clipboard.writeText(clipboardText);
		alert('Copied to clipboard!');
	} catch (err) {
		console.error('Failed to copy: ', err);
		alert('Failed to copy text');
	}
};
